const steps = [      
  {
    content: 
        'In this tutorial we would like to give you a quick overview of the different functionalities that the lab offers.',
    placement: "center" as const,
    target: '.globalTutorialAnchor',
    title: 'Welcome to the VisionLab!'
  },
  //Step 1
  //Pause, clicking Add Pipeline triggers unpause
  {
    content: 'Start off by creating a new Pipeline!',
    placement: 'right' as const,
    target: '.test5',
    hideFooter: true,
  },
  {
    content: 'Here you can choose a name as well as an icon for your pipeline. You can also create a new pipeline from an existing one by either copying from another one or by uploading.',
    placement: 'bottom' as const,
    target: '.pipelinedialog',
  },
  //Step 3
  //Pause, closing the Dialog triggers unpause
  {
    content: 'For now, simply click "Create Pipeline" to continue.',
    placement: 'bottom' as const,
    target: '.pipelinedialog',
    hideFooter: true,
  },
  //Step 4
  //Pause, opening the Pipeline Editor triggers unpause
  {
    content: 'Select your newly created Pipeline!',
    placement: 'right' as const,
    target: '.pipelineList-wrapper',
    hideFooter: true,
  },
  {
    content: 'On this screen you will have the possibility to select images and apply certain filters/services, e.g. a gaussian filter, to them.',
    placement: "center" as const,
    target: '.globalTutorialAnchor',
    title: 'Welcome to the Pipeline Editor!'
  },
  {
    content: `Let's start by selecting a starting image that we want to apply filters to. For this, open the 'Image Sources' tab on the right side of the screen.`,
    placement: 'left' as const,
    target: '.camera-module',
    hideFooter: true,
  },
  //Step 7
  //Pause, uncollapsing Basic Operations triggers unpause
  {
    content: `Now select 'Single Image'`,
    placement: 'left' as const,
    target: '.image-service',
    hideFooter: true,
  },
  //Step 8
  //Clicking Create Service triggers unpause
  {
    content: `Give your image a name, select one of the preset images and click 'Create Service'`,
    placement: 'bottom' as const,
    target: '.addServiceDialog',
    hideFooter: true,
  },
  //Step 9
  {
    content: `Next, let us apply a smoothing filter to the image. For this, open the 'Filter Operations' tab.`,
    placement: "left" as const,
    target: '.filter-module',
    hideFooter: true,
  },
  //Step 10
  {
    content: `Select the "Smooth" Service`,
    placement: "left" as const,
    target: '.smooth-service',
    hideFooter: true,
  },
  //Step 11
  {
    content: `Again, give your new Service a name and set the required parameters`,
    placement: "bottom" as const,
    target: '.addServiceDialog',
    spotlightPadding: 60,
  },
  //Step 12
  {
    content: `If you are unsure what parameters to choose, try 'Gaussian' for filter, '7' for Kernel Size and 'Constant Black' for Border Type`,
    placement: "bottom" as const,
    target: '.addServiceDialog',
    spotlightPadding: 60,
    hideFooter: true,
  },
  //Step 13
  {
    content: `Now that we have our two desired services (Our starting image and a filter that we want to apply to it), we need link them`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
  //Step 14
  {
    content: `Click on 'Add'`,
    placement: "top" as const,
    target: '.add-action',
    hideFooter: true,
  },
  //Step 15
  {
    content: `Click on 'Edge'`,
    placement: "top" as const,
    target: '.addEdge-button',
    hideFooter: true,
  },
  //Step 16
  {
    content: `Select source and destination nodes from the graph in the correspoding dropdown menus. Select your Image as source and the smoothing service as destination and click 'Create Edge'`,
    placement: "bottom" as const,
    target: '.addEdge-dialog',
    hideFooter: true,
    spotlightPadding: 70,
  },
  //Step 17
  {
    content: `If you want to delete a node or an edge in your graph, first select it with a left click and either click the 'Delete' button in the action bar below or press the 'Del.' on your keyboard. Try it with the edge, that we just created!`,
    placement: "bottom" as const,
    target: '.PipelineEditor-paper',
    hideFooter: true,
  },
  //Step 18
  {
    content: `Now that we deleted the edge, we need create another one. A faster way to do this, is to hold down your Shift key and then click and hold your source node. While still holding both left Mousebutton and shift, hover over the destination node and release both buttons. If you are having difficulty with this, you can alternatively repeat the same steps as before.`,
    placement: "bottom" as const,
    target: '.PipelineEditor-paper',
    hideFooter: true,
  },
  //Step 19
  {
    content: `You should save your pipeline regularily, to do this click the blue 'Save' button in the upper right corner. Your progress automatically saves every 5 minutes.`,
    placement: "left" as const,
    target: '.save-button',
    hideFooter: true,
  },
  //Step 20
  {
    content: `To execute your pipeline click the green 'Run' button.`,
    placement: "left" as const,
    target: '.run-button',
    hideFooter: true,
  },
  //Step 21
  {
    content: `Great! The pipeline produced a result. Navigate over to the results page to see it. For this click the 'Results' button at the top.`,
    placement: "bottom" as const,
    target: '.navbarResults-button',
    hideFooter: true,
  },
  //Step 22
  {
    content: `This list contains all the currently stored results of all your pipelines. New results that you have not seen yet are highlighted in yellow.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
  //Step 23
  {
    content: `To see your result in more detail, click the name of your pipeline.`,
    placement: "top" as const,
    target: '.resultsTable',
    hideFooter: true,
  },
  //Step 24
  {
    content: `This list shows all the intermediate results that your pipeline produced along the way. In our case that is just two, one for the starting image and one for the image, after we applied a filter to it.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
  //Step 25
  {
    content: `To get a more detailed view of one of the images simply click on one of the service names in the left most column.`,
    placement: "top" as const,
    target: '.serviceTable',
    hideFooter: true,
  },
  //Step 26
  {
    content: `Here you can inspect each indivudally produced image in detail.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
   //Step 27
   {
     content: `This block shows some information associated with this service (e.g. Name, Type, Parameters, etc.)`,
     placement: "top" as const,
     target: '.results-serviceInfoList',
   },
  //Step 28
  {
    content: `This list contains all services of your pipeline and serves as a quick navigation menu to switch between the different services.`,
    placement: "left" as const,
    target: '.results-serviceQuickNavMenu',
  },
  //Step 29
  {
    content: `You can inspect the image in more detail by simply clicking it.`,
    placement: "bottom" as const,
    target: '.result-serviceImage',
    hideFooter: true,
  },
  //Step 30
  {
    content: `Finally, you can zoom in and out of the image by using your mouse wheel. You can also click and drag the image so look at the different parts.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
  //Step 31
  {
    content: `That covers all the basics on how to use the lab. You can repeat this tutorial as many times as you want by simply clicking the questionmark icon in the top right.`,
    placement: "center" as const,
    target: '.globalTutorialAnchor',
  },
]

export default steps;